export const testResultsJA  = {
    "topLabel": "\u4EE5\u4E0B\u306B\u691C\u67FB\u3068\u30E9\u30DC\u304B\u3089\u306E\u7D50\u679C\u3092\u5165\u529B\u3057\u307E\u3059\u3002Ambry Genetics\u306E\u691C\u67FB\u306F\u540C\u671F\u3067\u304D\u307E\u3059\u3002",
    "negative": "\u9670\u6027",
    "delete": "\u524A\u9664",
    "testDetails": "\u691C\u67FB\u8A73\u7D30",
    "seeDetails": "\u8A73\u7D30\u3092\u898B\u308B...",
    "gene": "\u907A\u4F1D\u5B50",
    "variant": "\u5909\u7570",
    "classification": "\u5206\u985E",
    "priorClassification": "\u4E8B\u524D\u5206\u985E",
    "addRow": "\u884C\u306E\u8FFD\u52A0",
    "deleteRow": "\u884C\u306E\u524A\u9664",
    "cancel": "\u30AD\u30E3\u30F3\u30BB\u30EB",
    "save": "\u4FDD\u5B58",
    "other": "\u305D\u306E\u4ED6",
    "singleSite": "\u30B7\u30F3\u30B0\u30EB\u30B5\u30A4\u30C8",
    "documents": "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8",
    "actions": "\u30A2\u30AF\u30B7\u30E7\u30F3",
    "lab": "\u30E9\u30DC",
    "test": "\u691C\u67FB",
    "submittedDate": "\u63D0\u51FA\u65E5",
    "reportedDate": "\u5831\u544A\u65E5",
    "reclassDate": "\u518D\u5206\u985E\u65E5",
    "status": "\u30B9\u30C6\u30FC\u30BF\u30B9",
    "result": "\u7D50\u679C",
    "document": "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8",
    "notes": "\u30E1\u30E2",
    "Delete Test": "\u691C\u67FB\u306E\u524A\u9664",
    "Delete Document": "\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u306E\u524A\u9664",
    "Ambry Orders - Setup": "Ambry\u30AA\u30FC\u30C0\u30FC - \u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    "Multiple Reports": "\u8907\u6570\u306E\u30EC\u30DD\u30FC\u30C8",
    "deleteTestConfirm": "\u3053\u306E\u691C\u67FB\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?",
    "deleteDocConfirm": "\u3053\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B?",
    "ambryKeysMessage": "\u3053\u306E\u6A5F\u80FD\u306B\u3088\u308A\u3001Progeny\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9\u304B\u3089\u8A3A\u65AD\u691C\u67FB\u3092\u76F4\u63A5\u30AA\u30FC\u30C0\u30FC\u3067\u304D\u3001\u60A3\u8005\u304A\u3088\u3073\u5BB6\u7CFB\u60C5\u5831\u3092\u30C7\u30B8\u30BF\u30EB\u3067\u5B89\u5168\u306BAmbry Genetics\u306B\u9001\u4FE1\u3067\u304D\u307E\u3059\u3002\u691C\u67FB\u7D50\u679C\u3082\u81EA\u52D5\u7684\u306BProgeny\u306B\u540C\u671F\u3055\u308C\u307E\u3059\u3002<br/> <br/>  Ambry Genetics\u306B\u30B5\u30A4\u30F3\u30A2\u30C3\u30D7\u3057\u3066\u3053\u306E\u30B5\u30FC\u30D3\u30B9\u3078\u306E\u9001\u4FE1\u3092\u5B89\u5168\u306B\u8A8D\u8A3C\u3059\u308B\u306B\u306F\u3001\u30EF\u30F3\u30BF\u30A4\u30E0\u8A2D\u5B9A\u304C\u5FC5\u8981\u3067\u3059\u3002\u3053\u306E\u30D7\u30ED\u30BB\u30B9\u3092\u958B\u59CB\u3059\u308B\u306B\u306F\u3001Progeny\u30B5\u30DD\u30FC\u30C8\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002   <br/> <br/>  \u4E0B\u306E\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001Progeny\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u7D42\u4E86\u3057\u3001Progeny\u30B5\u30DD\u30FC\u30C8Web\u30B5\u30A4\u30C8\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002   <br/> <br/>  <a target='_blank' href='http://www.progenygenetics.com/support/ambryorder'>Progeny\u30B5\u30DD\u30FC\u30C8\u306E\u9023\u7D61\u5148 -  <br/>   http://www.progenygenetics.com/support/ambryorder</a>",
    "multipleReportsMessage": "\u3053\u306E\u4EBA\u7269\u306B\u306F\u8907\u6570\u306E\u30EC\u30DD\u30FC\u30C8\u304C\u3042\u308A\u307E\u3059\u3002\u6DFB\u4ED8\u306E\u30EC\u30DD\u30FC\u30C8\u3092\u78BA\u8A8D\u3057\u3066\u304B\u3089\u3001\u30A6\u30A3\u30F3\u30C9\u30A6\u3067\u7D50\u679C\u3092\u691C\u8A3C\u3057\u3001\u9069\u5B9C\u624B\u52D5\u3067\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    "Delete": "\u30AD\u30E3\u30F3\u30BB\u30EB",
    "Cancel": "\u30AD\u30E3\u30F3\u30BB\u30EB",
    "Close": "\u9589\u3058\u308B",
    "Pathogenic": "\u75C5\u539F\u6027",
    "Likely Pathogenic": "\u75C5\u539F\u6027\u306E\u53EF\u80FD\u6027\u304C\u9AD8\u3044",
    "VUS": "VUS（\u75C5\u7684\u610F\u7FA9\u4E0D\u660E）",
    "Likely Benign": "\u826F\u6027\u306E\u53EF\u80FD\u6027\u304C\u9AD8\u3044",
    "Negative": "\u9670\u6027",
    "In Progress": "\u9032\u884C\u4E2D",
    "Reported": "\u5831\u544A\u6E08",
    "Cancelled": "\u30AD\u30E3\u30F3\u30BB\u30EB\u6E08\u307F",
    "viewTestDetails": "\u691C\u67FB\u8A73\u7D30\u306E\u8868\u793A",
    "deleteTest": "\u691C\u67FB\u306E\u524A\u9664",
    "testResultsFor": "\u691C\u67FB\u7D50\u679C",
    "newTest": "\u65B0\u898F\u691C\u67FB",
    "noResults": "\u8868\u793A\u3059\u308B\u691C\u67FB\u7D50\u679C\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    "wrongData": "Data for test results loaded incorrectly. Please close and open test results again.",
    "serverError": "Server error",
    "blacklistFilesErrorMessage": "You may not upload files of this type",
    "geneCount": "Gene Count",
    "otherLab": "Other Lab",
    "otherTest": "Other Test",
    "Must not exceed 100 characters": "Must not exceed 100 characters",
    "Must not exceed 50 characters": "Must not exceed 50 characters",
    "New Custom Panel": "New Custom Panel",
    'Cancel': 'Cancel',
    'Create': 'Create',
    'Failed to save folder': 'Failed to save folder',
    'Add New Custom Panel': 'Add New Custom Panel',
    'Name': 'Name',
    'Failed to get folders': 'Failed to get folders',
    'Delete Panel': 'Delete Panel',
    'Custom Test Name': 'Custom Test Name',
    'Failed to get labs': 'Failed to get labs',
    'Save As': 'Save As',
    'The field is required': 'The field is required',
    'Load Custom Panel': 'Load Custom Panel',
    'Load': 'Load',
    'Failed to get panel format': 'Failed to get panel format',
    'Failed to create panel': 'Failed to create panel',
    'Failed to update panel': 'Failed to update panel',
    'Failed to load format': 'Failed to load format',
    'Failed to create folder': 'Failed to create folder',
    'Custom Panel Details': 'Custom Panel Details',
    'Save As Custom Panel': 'Save As Custom Panel',
    'OK': 'OK',
    'Folder name already exists': 'Folder name already exists',
    'Format name already exists': 'Format name already exists',
    Requires: 'Requires',
    format: 'format',
    'Failed to check panel name': 'Failed to check panel name',
    'existingCustomPanel': 'This name has already been used, would you like to overwrite the current format being used by this name?',
    'Overwrite': 'Overwrite',
    'Failed to check test name': 'Failed to check test name',
    'Test name already exists': 'Test name already exists',
    'Panel name already exists': 'Panel name already exists',
};